// newsletter-modal.js

/**
 * Shows the newsletter modal after a specified delay.
 * @param {number} delay - Time in milliseconds.
 */
function setTimeoutPopup(delay) {
    setTimeout(function () {
        jQuery("body").addClass("modal-open");
        const modal = jQuery(".newsletter-modal");
        modal.fadeIn(300).addClass("visible");
    }, delay);
}

/**
 * Stores a key-value pair in localStorage with an expiry time.
 * @param {string} key 
 * @param {*} value 
 * @param {number} days - Lifespan of the stored item in days.
 */
function setWithExpiry(key, value, days) {
    const now = new Date();
    const expiryDate = new Date();
    expiryDate.setDate(now.getDate() + days);
    const item = {
        value: value,
        expiry: expiryDate
    };
    localStorage.setItem(key, JSON.stringify(item));
}

/**
 * Retrieves a key's value from localStorage if it has not expired yet.
 * @param {string} key 
 * @returns {*|null}
 */
function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    
    const item = JSON.parse(itemStr);
    const now = new Date();
    
    if (now.getTime() > new Date(item.expiry).getTime()) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

/**
 * Initializes all the behavior and event listeners for the newsletter modal.
 */
export function initNewsletterModal() {
    
    // 1. Setup close triggers (backdrop or close button)
    jQuery(".modal-backdrop, .modal-close").on("click", function () {
        jQuery(this)
            .closest(".custom-modal")
            .removeClass("visible")
            .fadeOut(300, function () {
                jQuery("body").removeClass("modal-open");
            });
    });

    // / 2. Fetch or update current newsletter status
    let status = getWithExpiry("newsletter_status");
    if (status) {
        status = Number(status);
        if (status < 4) {
            status = status + 1; // Update local variable
            setWithExpiry("newsletter_status", status, 183); // Save to localStorage
        }
    } else {
        status = 1;
        setWithExpiry("newsletter_status", status, 183);
    }

    // 3. Determine and trigger delay timeout
    if (status == 1) {
        setTimeoutPopup(20000); // 20s
    } else if (status == 2) {
        setTimeoutPopup(30000); // 30s
    } else if (status == 3) {
        setTimeoutPopup(40000); // 40s
    }

    // 4. Handle auto-close on successful Contact Form 7 submission
    document.addEventListener("wpcf7mailsent", function (e) {
        if (e.detail && e.detail.contactFormId == "8267") {
            setTimeout(function () {
                jQuery(".newsletter-modal .modal-close").click();
            }, 1000);
            setWithExpiry("newsletter_status", 4, 183);
        }
    }, false);
}
